import { useDispatch, useSelector } from 'react-redux';
import { getGenericError } from 'lib/selectors/genericErrors';
import { usePrevious } from 'lib/utils';
import { useCallback, useEffect } from 'react';
import { dispatchShowModal, dispatchHideModal } from 'utils/modals';
import { GENERIC_5XX_ERROR_MODAL } from 'constants/shared/modalTypes';
import { useNavigate } from 'react-router-dom';
import { clearGenericError } from 'lib/actions';

const useGenericErrorModal = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const genericError = useSelector(getGenericError);
    const prevProps = usePrevious({ genericError });

    const handleGoBack = useCallback(() => {
        dispatch(clearGenericError());
        dispatchHideModal(dispatch);
        navigate(-1);
    }, [dispatch, navigate]);

    useEffect(() => {
        if (genericError && !prevProps?.genericError) {
            dispatchShowModal(dispatch, GENERIC_5XX_ERROR_MODAL, {
                message: genericError,
                goBack: handleGoBack,
                hideModal: () => dispatchHideModal(dispatch),
            });
        }
    }, [genericError, prevProps?.genericError, dispatch, handleGoBack]);

    useEffect(() => {
        if (!genericError && prevProps?.genericError) {
            dispatchHideModal(dispatch);
        }
    }, [genericError, prevProps?.genericError, dispatch]);
};

export default useGenericErrorModal;
